import React from "react";
import { motion } from "framer-motion";

export default function PageHeader({
    title,
    subtitle,
    actions,
    back,
}: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    back?: React.ReactNode;
}) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6"
        >
            <div className="min-w-0">
                {back}
                <h1 className="text-2xl md:text-3xl font-bold text-white tracking-tight">{title}</h1>
                {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex flex-wrap gap-2 shrink-0">{actions}</div>}
        </motion.div>
    );
}